import { TileSection } from 'foundations-components/transitional/components/Tile';
import { Media } from 'foundations-components/transitional/components/Media';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageBody = ({
  align = 'start',
  children
}) => /*#__PURE__*/_jsx(TileSection, {
  children: /*#__PURE__*/_jsx(Media, {
    align: align,
    children: children
  })
});
TileMessageBody.displayName = 'TileMessageBody';
export default TileMessageBody;